function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as UserApi from "../ajax/UserApi";
import * as ProfileApi from "../ajax/ProfileApi";
import IntlMessage from '../commons/Intl';
import { Label, Errors, Action, Placeholder, User, Options, Authorities, EnableOptions } from '../commons/IntlMessages';
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // ユーザー登録モーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 追加
   */

  Mode[Mode["Add"] = 1] = "Add";
  /**
   * 更新
   */

  Mode[Mode["Modify"] = 2] = "Modify";
  /**
   * プロフィール
   */

  Mode[Mode["Profile"] = 3] = "Profile";
})(Mode || (Mode = {}));
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);

    switch (props.mode) {
      case Mode.Add:
        _this.state = {
          Modal: null,
          UserId: "",
          UserName: "",
          UserMailAddress: "",
          OrganizationId: _this.props.organizationId,
          AuthorityId: "",
          ThumbnailFileName: "",
          CanSupport: "0",
          ContractManagerFlag: false,
          GuestOnly: true,
          ErrorMessages: []
        };
        break;

      case Mode.Modify:
        var checkResult = _this.checkDomain(_this.props.domain, _this.props.userMailAddress);

        _this.state = {
          Modal: null,
          UserId: _this.props.userId,
          UserName: _this.props.userName,
          UserMailAddress: _this.props.userMailAddress,
          OrganizationId: _this.props.organizationId,
          AuthorityId: !checkResult && _this.props.authorityId != "5" ? "" : _this.props.authorityId,
          ThumbnailFileName: _this.props.thumbnailFileName,
          CanSupport: _this.props.canSupport,
          ContractManagerFlag: _this.props.contractManagerFlag,
          GuestOnly: !checkResult,
          ErrorMessages: []
        };
        break;

      case Mode.Profile:
        _this.state = {
          Modal: null,
          UserId: _this.props.userId,
          UserName: _this.props.userName,
          UserMailAddress: _this.props.userMailAddress,
          OrganizationId: _this.props.organizationId,
          AuthorityId: _this.props.authorityId,
          ThumbnailFileName: _this.props.thumbnailFileName,
          CanSupport: _this.props.canSupport,
          ContractManagerFlag: _this.props.contractManagerFlag,
          GuestOnly: true,
          ErrorMessages: []
        };
        break;

      default:
        throw Error();
    }

    _this.GetThumbnailUrl();

    return _this;
  }

  _createClass(MainComponent, [{
    key: "GetThumbnailUrl",
    value: function GetThumbnailUrl() {
      var _this2 = this;

      if (!this.props.userId || !this.props.thumbnailFileName) {
        if (this.props.curUserId == this.props.userId) {
          if ($("#headerThumbnail")) {
            $("#headerThumbnail").css("background-image", 'url("/assets/img/user_thumbnail_default.jpg")');
          }
        }

        $("#usermodaliconframe").css("background-image", 'url("/assets/img/user_thumbnail_default.jpg")');
        return;
      }

      if (this.props.mode == Mode.Profile) {
        ProfileApi.GetThumbnail(this.state.UserId, this.state.ThumbnailFileName, function (blob) {
          if (_this2.props.curUserId == _this2.props.userId) {
            if ($("#headerThumbnail")) {
              $("#headerThumbnail").css("background-image", 'url(' + window.URL.createObjectURL(blob) + ')');
            }
          }

          $("#usermodaliconframe").css("background-image", 'url(' + window.URL.createObjectURL(blob) + ')');
        });
      } else {
        UserApi.GetThumbnail(this.state.UserId, this.state.ThumbnailFileName, function (blob) {
          if (_this2.props.curUserId == _this2.props.userId) {
            if ($("#headerThumbnail")) {
              $("#headerThumbnail").css("background-image", 'url(' + window.URL.createObjectURL(blob) + ')');
            }
          }

          $("#usermodaliconframe").css("background-image", 'url(' + window.URL.createObjectURL(blob) + ')');
        });
      }
    }
    /**
     * ユーザー名を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateUserName",
    value: function updateUserName(e) {
      this.setState({
        UserName: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * メールアドレスを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateUserMailAddress",
    value: function updateUserMailAddress(e) {
      var userMailAddress = e.target.value.substring(0, e.target.maxLength).trim();
      var checkResult = this.checkDomain(this.props.domain, userMailAddress);
      this.setState({
        UserMailAddress: userMailAddress,
        AuthorityId: !checkResult && this.state.AuthorityId != "5" ? "" : this.state.AuthorityId,
        GuestOnly: !checkResult
      });
    }
    /**
     * メールアドレスのドメインを確認します。
     *
     * @param domain 組織のドメイン
     * @param address メールアドレス
     */

  }, {
    key: "checkDomain",
    value: function checkDomain(domain, address) {
      // ドメイン設定、メールアドレスが未入力の場合、ゲストのみ
      if (domain == null || domain.trim() == "" || address == null || address.trim() == "") {
        return false;
      } // ドメインを分解


      var guestOnly = true;
      var domains = domain.split(',');

      for (var i = 0; i < domains.length; i++) {
        var _domain = domains[i];
        if (_domain.trim() == "") continue;
        if (!address.trim().endsWith(_domain.trim())) continue; // ドメインに一致した場合は、ゲスト以外を選択可能

        guestOnly = false;
        break;
      }

      return !guestOnly;
    }
    /**
     * 権限を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateAuthority",
    value: function updateAuthority(e) {
      this.setState({
        AuthorityId: e.target.value
      });
    }
    /**
     * サポート可否を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateCanSupport",
    value: function updateCanSupport(e) {
      this.setState({
        CanSupport: e.target.value
      });
    }
    /**
     * 契約管理者か否かを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateContractManagerFlag",
    value: function updateContractManagerFlag(e) {
      this.setState({
        ContractManagerFlag: e.target.checked
      });
    }
    /**
     * メールアドレスの入力有無・整合性を検証します。
     */

  }, {
    key: "isInvalidEmailAddress",
    value: function isInvalidEmailAddress() {
      return !this.state.UserMailAddress.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/);
    }
    /**
     * 「登録」ボタン押下時の処理を行います。
     */

  }, {
    key: "onEntry",
    value: function onEntry() {
      var _this3 = this;

      if (this.state.Modal == null) {
        throw Error();
      }

      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        this.state.ErrorMessages.length = 0;

        if (!this.isInvalidEmailAddress()) {
          if (!(this.state.AuthorityId == "1" || this.state.AuthorityId == "2" || this.state.AuthorityId == "3" || this.state.AuthorityId == "4" || this.state.AuthorityId == "5")) {
            this.state.ErrorMessages.push(intl.format(Errors.DataNotSelected, {
              title: intl.format(Label.Authority)
            }));
          }
        }

        var result = this.state.UserMailAddress.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/);

        if (!result) {
          this.state.ErrorMessages.push(intl.format(Errors.InputWrongFormat, {
            title: intl.format(Label.MailAddress)
          }));
        }

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        this.props.onEntry(this.state.UserName, this.state.UserMailAddress, this.state.AuthorityId, this.state.CanSupport, this.state.ContractManagerFlag, function () {
          if (_this3.state.Modal == null) {
            throw Error();
          }

          _this3.state.Modal.modal('hide');
        });
      }
    }
    /**
     * 「更新」ボタン押下時の処理を行います。
     */

  }, {
    key: "onModify",
    value: function onModify() {
      var _this4 = this;

      if (this.state.Modal == null || !this.props.userId) {
        throw Error();
      }

      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        this.state.ErrorMessages.length = 0;

        if (!this.props.userId) {
          throw Error();
        }

        if (!(this.state.AuthorityId == "1" || this.state.AuthorityId == "2" || this.state.AuthorityId == "3" || this.state.AuthorityId == "4" || this.state.AuthorityId == "5")) {
          this.state.ErrorMessages.push(intl.format(Errors.DataNotSelected, {
            title: intl.format(Label.Authority)
          }));
        }

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        this.props.onModify(this.props.userId, this.state.UserName, this.state.UserMailAddress, this.state.OrganizationId, this.props.authorityId, this.state.AuthorityId, this.state.CanSupport, this.state.ContractManagerFlag, this.props.updateDateTime, function () {
          if (_this4.state.Modal == null) {
            throw Error();
          }

          _this4.state.Modal.modal('hide');
        });
      }
    }
    /**
     * 「削除」ボタン押下時の処理を行います。
     */

  }, {
    key: "onDelete",
    value: function onDelete() {
      if (this.state.Modal == null || !this.props.userId) {
        throw Error();
      }

      this.state.ErrorMessages.length = 0;
      this.props.onDelete(this.props.userId, this.props.updateDateTime);
      this.state.Modal.modal('hide');
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this5 = this;

      var modal = $('#UserModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function () {
        _this5.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "UserModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modalIcon"
      }, /*#__PURE__*/React.createElement("div", {
        id: "usermodaliconframe",
        className: "thumbnailicon40frame"
      })), /*#__PURE__*/React.createElement("h3", null, intl.format(User.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-9 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "UserName"
      }, intl.format(Label.UserName)), /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "UserName",
        id: "UserName",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 40,
        onChange: function onChange(e) {
          return _this6.updateUserName(e);
        },
        value: this.state.UserName,
        tabIndex: 101,
        placeholder: intl.format(Placeholder.Letters, {
          value: "40"
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "UserName",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, this.props.mode == Mode.Add && [/*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "UserMailAddress"
      }, intl.format(Label.MailAddress)), /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "UserMailAddress",
        id: "UserMailAddress",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 254,
        onChange: function onChange(e) {
          return _this6.updateUserMailAddress(e);
        },
        value: this.state.UserMailAddress,
        tabIndex: 102,
        placeholder: intl.format(Placeholder.Letters, {
          value: "254"
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "UserMailAddress",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      }))], (this.props.mode == Mode.Modify || this.props.mode == Mode.Profile) && [/*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "UserMailAddress"
      }, intl.format(Label.MailAddress)), /*#__PURE__*/React.createElement("label", {
        className: "col-9 col-form-label"
      }, this.state.UserMailAddress)]), this.props.mode != Mode.Profile && !this.state.GuestOnly && !this.isInvalidEmailAddress() && /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "AuthorityId"
      }, intl.format(Label.Authority)), /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "AuthorityId",
        name: "AuthorityId",
        onChange: function onChange(e) {
          return _this6.updateAuthority(e);
        },
        value: this.state.AuthorityId,
        tabIndex: 103
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, intl.format(Options.Select)), this.props.curOrganizationId == this.props.organizationId && this.props.curUserAuthorityId == 1 && /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(Authorities.SystemAdmin)), (this.props.curUserAuthorityId == 1 || this.props.curOrganizationId == this.props.organizationId && this.props.curUserAuthorityId == 2) && /*#__PURE__*/React.createElement("option", {
        value: "2"
      }, intl.format(Authorities.OrgAdmin)), /*#__PURE__*/React.createElement("option", {
        value: "3"
      }, intl.format(Authorities.User)), /*#__PURE__*/React.createElement("option", {
        value: "5"
      }, intl.format(Authorities.Guest))))), this.props.mode != Mode.Profile && this.state.GuestOnly && !this.isInvalidEmailAddress() && /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "AuthorityId"
      }, intl.format(Label.Authority)), /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "AuthorityId",
        name: "AuthorityId",
        onChange: function onChange(e) {
          return _this6.updateAuthority(e);
        },
        value: this.state.AuthorityId,
        tabIndex: 103
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, intl.format(Options.Select)), /*#__PURE__*/React.createElement("option", {
        value: "5"
      }, intl.format(Authorities.Guest))))), this.props.mode != Mode.Profile && !this.state.GuestOnly && !this.isInvalidEmailAddress() && this.props.curOrganizationId == this.state.OrganizationId && this.props.curUserAuthorityId == 1 && this.state.AuthorityId != "4" && /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "CanSupport"
      }, intl.format(Label.CanSupport)), /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "CanSupport",
        name: "CanSupport",
        onChange: function onChange(e) {
          return _this6.updateCanSupport(e);
        },
        value: this.state.CanSupport,
        tabIndex: 104
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(EnableOptions.Disabled)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(EnableOptions.Enabled))))), this.props.mode != Mode.Profile && !this.state.GuestOnly && !this.isInvalidEmailAddress() && [1, 2].some(function (x) {
        return x == _this6.props.curUserAuthorityId;
      }) && "2" == this.state.AuthorityId && /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "ContractManagerFlag"
      }, intl.format(Label.ContractManager)), /*#__PURE__*/React.createElement("div", {
        className: "col-9 align-items-center row contractManagerFlagCheckbox"
      }, /*#__PURE__*/React.createElement("div", {
        className: "checkbox icheck-asbestos"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "ContractManagerFlag",
        name: "ContractManagerFlag",
        onChange: this.updateContractManagerFlag.bind(this),
        checked: this.state.ContractManagerFlag
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: "ContractManagerFlag"
      }, " ")))))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, this.props.mode == Mode.Add && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onEntry.bind(this),
        tabIndex: -1
      }, intl.format(Action.Entry)), (this.props.mode == Mode.Modify || this.props.mode == Mode.Profile) && /*#__PURE__*/React.createElement("button", {
        key: "onModify",
        type: "button",
        className: "btn btn-primary",
        onClick: this.onModify.bind(this),
        tabIndex: -1
      }, intl.format(Action.Update)), this.props.mode == Mode.Modify && this.props.curUserId != this.props.userId && (this.props.curUserAuthorityId == 1 && this.props.authorityId == "2" || this.props.authorityId == "3" || this.props.authorityId == "4" || this.props.authorityId == "5") && /*#__PURE__*/React.createElement("button", {
        key: "onDelete",
        type: "button",
        className: "btn btn-default",
        onClick: this.onDelete.bind(this),
        tabIndex: -1
      }, intl.format(Action.Delete))))));
    }
  }]);

  return MainComponent;
}(React.Component);

export { MainComponent as default };